import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BenefitChangeRequest } from '@app/models/benefits/benefit-change-request.model';
import { AuthService } from '@app/services';
import { environment } from '@env/environment';

@Injectable({
    providedIn: 'root',
})
export class BenefitChangeRequestService {
    constructor(
        private http: HttpClient,
        private auth: AuthService
    ) {}

    onChangeRequestStatusAcknowledge(benefitPlanId: number, changeRequestId: number): Promise<unknown> {
        const url = this.getAcknowledgeEndpoint(benefitPlanId, changeRequestId);
        const payload = {};

        return this.http.post(url, payload).toPromise();
    }

    async getAllChangeRequestsBasedOnAcknowledgement(benefitPlanId: number): Promise<BenefitChangeRequest[]> {
        const isAcknowledged = false;

        const [allChangeRequests] = await BenefitChangeRequest.param('company', this.auth.company.id)
            .param('benefitPlan', benefitPlanId)
            .where('employeeId', this.auth.employee.id)
            .where('is_acknowledged', isAcknowledged)
            .get();

        return allChangeRequests;
    }

    async getPendingChangeRequests(benefitPlanId: number): Promise<BenefitChangeRequest[]> {
        const [allChangeRequests] = await BenefitChangeRequest.param('company', this.auth.company.id)
            .param('benefitPlan', benefitPlanId)
            .where('employeeId', this.auth.employee.id)
            .whereIn('status', ['draft', 'pending'])
            .get();

        return allChangeRequests;
    }

    private getAcknowledgeEndpoint(benefitPlanId: number, changeRequestId: number): string {
        return (
            environment.api +
            `/v2/benefitManagement/companies/${this.auth.company.id}/benefitPlans/${benefitPlanId}/changeRequest/${changeRequestId}/acknowledge`
        );
    }
}
